"use client";
import { useFormContext } from "react-hook-form";
import { useHandleApiCall } from "./useHandleApiCall";
import { ApiCallsTypes } from "./contants";

/**
 * Confirms the vehicle candidate (from the SearchMtsbuMvs result array) picked
 * by the client, index 0 included — the backend always requires an explicit
 * confirm call before the flattened vehicle context variables are populated.
 *
 * `selectedVehicleIndex` is a registered context variable but isn't bound to
 * any rendered form field, so its value is set via `setValue` (the same
 * convention used for other system-only fields, see `useFieldsReset` in
 * Modals/AutoSearch/Success.tsx) right before the call, so it flows through
 * the normal getContextVariablesToApiCall resolution with its real id.
 */
export const useConfirmMtsbuVehicle = () => {
  const { setValue } = useFormContext();
  const { handleApiCallByName } = useHandleApiCall();

  const confirmMtsbuVehicle = (selectedIndex: number, cancelStepId?: string) => {
    setValue("selectedVehicleIndex", String(selectedIndex), { shouldDirty: true });

    return handleApiCallByName(ApiCallsTypes.CONFIRM_MTSBU_VEHICLE, false, {
      additionalParams: { onErrorData: { cancelStepId } },
    });
  };

  return { confirmMtsbuVehicle };
};
